export default __webpack_public_path__ + "static/media/math.b997993b.png";